<template>
	<div id="Forgetpwd" class="container">
		<div class='safestyle'>账号安全</div>
		<div class="g-ypxx" style="margin-top: 50px;">
			<p>
				<span class="ypxx-left">手机号</span>
				<span class="ypxx-right"><input type="text" v-model="mobile" placeholder="请输入您的手机号" /></span>
				<div class="clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">验证码</span>
				<span class="forget-right">
					<input type="text" class="code" v-model="code" placeholder="请输入手机验证码" />
					<input v-show="show" @click="send(mobile)" class="yzm-btn2" type="button" value="发送验证码"></span>
					<span v-show="!show" class="count2">{{count}} s</span>
				<div class="clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">密码</span>
				<span class="ypxx-right"><input type="password" v-model="password" placeholder="请输入密码" /></span>
				<div class="clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">确认密码</span>
				<span class="ypxx-right"><input type="password" v-model="password_confirm" placeholder="请再次输入密码" /></span>
				<div class="clearfix"></div>
			</p>
			<center><input @click="forgetpwd" type="button" class="g-btn" value="确认提交"> </center>

		</div>
	</div>
</template>
<script>
	import Axios from 'axios'
	export default {
		data() {
			return {
				show: true,
				count: '',
				timer: null,
				mobile: '',
				password: '',
				password_confirm: '',
				code: ''

			}
		},
		methods: {
			send(mobile) {
				var api = "http://api.yopoo.cn/api/v1/code"
				if (mobile == "") {
					this.$message({
						message: '您未输入手机号！',
						type: 'warning',
						center: true

					});
				} else {
					let infor={
						mobile:this.mobile,
						state:Math.random().toString(36).substr(2)
						}
					this.$http.post(api,infor).then(
						res => {
							console.log(res);
							this.$message({
								message: res.data.msg,
								type: 'success',
								center: true

							});
							const TIME_COUNT = 90;//验证码倒计时
							if (!this.timer) {
								this.count = TIME_COUNT;
								this.show = false;
								this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
								} else {
									this.show = true;
									clearInterval(this.timer);
									this.timer = null;
								}
								}, 1000)
							}
						},
						err => {
							console.log(err);
						}
					);
				}
			},
			forgetpwd() {
				var api = 'http://api.yopoo.cn/api/v1/back'
				let updateinfo = {
					mobile: this.mobile,
					password: this.password,
					password_confirm: this.password_confirm,
					code: this.code,

				}
				Axios.post(api, updateinfo).then((res) => {


					if (res.data.code == 200) {

						this.$message({
							message: res.data.msg,
							type: 'success',
							center: true

						});
						setTimeout(() => {

							this.$router.push({
								path: '/login', //缺省页判断,有值则跳转详情页

							})
						}, 500);
					}
					if (res.data.code == 202) {
						this.$message({
							message: res.data.msg,
							type: 'error',
							center: true

						});

					}



				}).catch((res) => {

				})


			}

		}
	}
</script>
<style scoped>
	/* body{
		background: #F4F4F4;
		background-size: 100% auto;
		background-attachment: fixed;
	} */
	#Forgetpwd {
		background: #fff;
	}

	.safestyle {
		height: 60px;
		background: #C8B9A6;
		padding: 20px;
		text-align: center;
		line-height: 60px;
		color: #fff;
		font-size: 40px;
	}

	.g-ypxx input[type=password] {
		width: 350px;
		border-radius: 5px;
		border: 1px solid #d9d9d9;
		padding-left: 5px;
		height: 34px;
		font-size: 14px;
		color: #555;
		background: #f4f4f4;
	}

	.code {
		width: 250px !important;
		border-radius: 5px;
		border: 1px solid #d9d9d9;
		padding-left: 5px;
		height: 34px;
		font-size: 14px;
		color: #555;
		background: #f4f4f4;
	}

	.yzm-btn2,.count2{
		width: 93px !important;
		border-radius: 5px;
		border: 1px solid #d9d9d9;
		height: 34px;
		font-size: 14px;
		color: #555;
		background: #f4f4f4;

	}
.count2{
	margin-left: 5px;
	width: 93px!important;
	display: block;
	position: relative;
	float: left;
	text-align: center;
	line-height: 34px;
}
.forget-right{
	float: left;
    margin-left: 30px;


}

.yzm-btn2:hover{
	background: #e3e3e3;cursor: pointer;
}
	.ypxx-left {
		margin-left: 300px;
	}

	.login-btn {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/Forgetpwd.vue